import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('success', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0Z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6871 13.4719C30.2879 14.0727 30.2879 15.0468 29.6871 15.6476L18.8085 26.5262C18.6082 26.7265 18.3665 26.86 18.1109 26.9268L17.8517 26.9713H17.5895C17.2406 26.9416 16.8998 26.7932 16.6328 26.5262L10.1056 19.9991C9.50483 19.3983 9.50483 18.4242 10.1056 17.8234C10.7064 17.2226 11.6805 17.2226 12.2813 17.8234L17.7193 23.2616L27.5113 13.4719C28.1121 12.8711 29.0862 12.8711 29.6871 13.4719Z",
    fill: props.colors[1]
  }));
});